import React from 'react';
import { RANGE_SLIDER_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_LABEL_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_LABEL_MUI_DEFAULT_RULES } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_MUI_DEFAULT_RULES } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_RAILING_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_RAILING_MUI_DEFAULT_RULES } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_THUMB_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_THUMB_MUI_DEFAULT_RULES } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_TRACK_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_TRACK_MUI_DEFAULT_RULES } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RangeSliderInputWrapper } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';

export interface RangeSliderSameMinMaxFakeProps {
  /**
   * The number shown on both the left and right side of the fake slider
   */
  value: number;
}

/**
 * This component matches the visual style of MUI slider, if it were to allow a min and max value to be identical.
 * @param value
 * @constructor
 */
export const RangeSliderInputSameMinMaxFake = ({
  value,
}: RangeSliderSameMinMaxFakeProps) => {
  const thumbStyle = {
    ...RANGE_SLIDER_THUMB_MUI_DEFAULT_RULES,
    ...RANGE_SLIDER_THUMB_EXTRA_CSS,
  } as const;

  const labelStyle = {
    ...RANGE_SLIDER_LABEL_MUI_DEFAULT_RULES,
    ...RANGE_SLIDER_LABEL_EXTRA_CSS,
  } as const;

  return (
    <RangeSliderInputWrapper>
      <span
        style={{
          ...RANGE_SLIDER_MUI_DEFAULT_RULES,
          ...RANGE_SLIDER_EXTRA_CSS,
        }}
      >
        <span
          style={{
            ...RANGE_SLIDER_RAILING_MUI_DEFAULT_RULES,
            ...RANGE_SLIDER_RAILING_EXTRA_CSS,
          }}
        />
        <span
          style={{
            ...RANGE_SLIDER_TRACK_MUI_DEFAULT_RULES,
            left: '0%',
            width: '100%',
            ...RANGE_SLIDER_TRACK_EXTRA_CSS,
          }}
        />
        <span
          style={{
            left: '0%',
            ...thumbStyle,
          }}
        >
          <span style={labelStyle}>{value}</span>
        </span>
        <span style={{ left: '100%', ...thumbStyle }}>
          <span style={labelStyle}>{value}</span>
        </span>
      </span>
    </RangeSliderInputWrapper>
  );
};
